import { useAtomValue } from "jotai";
import { ReactNode } from "react";

import { store, userConfigAtom } from "~/atoms";
import useAcceptTermsOfServiceMutation from "~/hooks/useAcceptTermsOfServiceMutation";
import TermsOfServiceDialog from "~/pages/Auth/Login/TermsOfServiceDialog";
import { Env } from "~/utils/Env";
import { logout, saveUserConfig } from "~/utils/Helper";

type TermsOfServiceGateProps = {
  fallback: ReactNode;
  children: ReactNode;
};

const TermsOfServiceGate = ({
  fallback,
  children,
}: TermsOfServiceGateProps) => {
  const userConfig = useAtomValue(userConfigAtom);
  const acceptMutation = useAcceptTermsOfServiceMutation({
    onSuccess: ({ termsOfServiceAcceptanceTimestamp }) => {
      saveUserConfig({
        ...store.get(userConfigAtom),
        termsOfServiceAcceptanceTimestamp,
      });
    },
  });

  const hasPendingTerms =
    Env.VITE_TERMS_OF_SERVICE_ENABLED &&
    !!userConfig &&
    !userConfig.termsOfServiceAcceptanceTimestamp;

  if (!hasPendingTerms) return <>{children}</>;

  return (
    <>
      {fallback}
      <TermsOfServiceDialog
        isOpen
        onClose={logout}
        onAccept={() => acceptMutation.mutate()}
        isAccepting={acceptMutation.isPending}
      />
    </>
  );
};

export default TermsOfServiceGate;
